import React from "react";
import { Link } from "react-router-dom";
import { Mail, AtSign, ArrowUpRight } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const initials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0])
    .join("")
    .toUpperCase();

export const ProfileHero = () => {
  const auth = useAuth();
  const accent = "#ECB236";
  const user = auth.user || {};

  return (
    <div className="profile-hero">
      <div className="profile-hero-glow" aria-hidden="true" />

      <div className="profile-hero-main">
        <div className="profile-hero-avatar">
          {user.profileimageurlsmall || user.profileimageurl ? (
            <img
              src={user.profileimageurlsmall || user.profileimageurl}
              alt=""
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          ) : null}
          <span className="profile-hero-avatar-fallback">
            {initials(user.fullname || user.username || "?")}
          </span>
        </div>

        <div className="profile-hero-identity">
          <span className="profile-hero-status">
            <span className="profile-hero-status-dot" />
            Cuenta activa
          </span>
          <h1 className="profile-hero-name">{user.fullname || "Mi cuenta"}</h1>
        </div>
      </div>

      <div className="profile-hero-contact">
        <div className="profile-hero-contact-items">
          {user.email && (
            <span className="profile-hero-contact-item">
              <Mail size={14} strokeWidth={2} />
              {user.email}
            </span>
          )}
          {user.username && (
            <span className="profile-hero-contact-item">
              <AtSign size={14} strokeWidth={2} />
              {user.username}
            </span>
          )}
        </div>

        <Link
          to="/listcourses"
          className="profile-hero-cta"
          style={{ "--hero-accent": accent }}
        >
          Volver al campus
          <ArrowUpRight size={15} strokeWidth={2.5} />
        </Link>
      </div>
    </div>
  );
};

export default ProfileHero;
